export enum CookiesKeys {
  AdId = 'ad_id',
  DeleteAccount = 'DeleteAccount',
  Subscription = 'subscription',
  SubscriptionPurchase = 'subscriptionPurchase',
  BigOrderPurchase = 'bigOrderPurchase',
  WebViewToken = 'app_auth',
  AuthTokenName = '__new-fd-tk',
  IS_LOGGED_IN = '__new-fd-login'
}
